export default __webpack_public_path__ + "static/media/photo-12.43cf47ba.jpg";